import { AxiosResponse } from "axios";
import SecureClient from "../SecureClient";
import { UserLogEntry, UserLogFilter } from "./DTO";

export default class UserLogClient extends SecureClient {
	public getUserLog = (filter: UserLogFilter): Promise<AxiosResponse<UserLogEntry[]>> => {
		return this._api.get<UserLogEntry[]>('UserLog', this.userLogConfig(filter))
	}

	public getUserLogCount = (filter: UserLogFilter): Promise<AxiosResponse<number>> => {
		return this._api.get<number>('UserLog/Count', this.userLogConfig(filter))
	}

	private userLogConfig = (filter: UserLogFilter): object => ({
		headers: {
			...this.authorizationHeader,
			...this.acceptHeader(),
			...this.contentTypeHeader()
		},
		paramsSerializer: (v: object) => {
			const urlSearchParams = new URLSearchParams();
			for (const [key, value] of Object.entries(v)) {

				// do not set this to !value - it fails if the value is 0
				if (value === null || value === undefined)
					continue;

				if (Array.isArray(value)) {
					for (const item of value) {
						// same as above with !item 
						if (item === null || item === undefined)
							continue;

						urlSearchParams.append(key, item.toString());
					}
				} else {
					urlSearchParams.append(key, (value as string ?? '').toString());
				}
			}

			return urlSearchParams.toString();
		},
		params: {
			eventId: filter.eventId,
			userId: filter.userId,
			logLevel: filter.logLevel,
			eventDateFrom: filter.eventDateFrom,
			eventDateTo: filter.eventDateTo,
			pageNumber: filter.pageNumber,
			pageSize: filter.pageSize,
			sortBy: filter.sortBy
		}
	})
}